import { getAxiosInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Mission routes
 * ----------------------------
 */

export const getMissions = (query, force = false, callback) => {
    cachiosInstance.get(`/mission?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getUserMissions = (query, force = false, callback) => {
    cachiosInstance.get(`/user-mission?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getSingleUserMission = (userMissionId, callback) => {
    cachiosInstance.get(`/user-mission/${userMissionId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getMissionCategory = (callback) => {
    cachiosInstance.get(`/mission-category`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const newMission = (query, callback) => {
    getAxiosInstanceApi().post(`/mission?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const approveMission = (userMissionId, query, callback) => {
    getAxiosInstanceApi().post(`/user-mission/${userMissionId}/approve?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const newMissionCategory = (query, callback) => {
    getAxiosInstanceApi().post(`/mission-category?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateMissionCategory = (categoryId, query, callback) => {
    getAxiosInstanceApi().put(`/mission-category/${categoryId}?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const deleteMissionCategory = (categoryId, callback) => {
    getAxiosInstanceApi().delete(`/mission-category/${categoryId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateMission = (missionId, query, callback) => {
    getAxiosInstanceApi().put(`/mission/${missionId}?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const deleteMission = (missionId, callback) => {
    getAxiosInstanceApi().delete(`/mission/${missionId}`)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};